import style from "./ButtonC.module.css";

const ButtonC = ({ text, link }) => {
  return (
    <div className={style.divBtn}>
      <a href={link}>
        <button className={style.btn}> {text} </button>
      </a>
    </div>
  );
};

export default ButtonC;